// Credit: https://stackoverflow.com/a/23461268/2813613
function toType (obj) {

	return {}.toString
		.call(obj)
		.match(/\s([a-zA-Z]+)/)[1]
		.toLowerCase();

}

export default toType;
